/**
 * Creates function which is used to create translation key
 * @param {string} form
 * @param {string} field
 * @param {string} error
 */
const errorKey = (form, field, error) => `${form}.${field}.errors.${error}`

export default errorKey
